import React, { useEffect, useState, useRef } from "react";
import Loading from "./loading.js";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import { secretKey } from "./data";
import LeadQue from "./leadsQue.js";
import Doubles from "./duplicates.js";
import AdminPanel from "./adminPanel.js";
import LeadAss from "./leadsAss.js";
import SellerRank from "./sellerRank.js";
import TaskCalendar from "./taskCalendar.js";
import Recommendations from "./recommendations.js";
import CcForm from "./ccForm.js";
import LeadOpinions from "./leadOpinions.js";
import LeadFinalized from "./leadFinalized.js";
import LeadRek from "./leadsRek.js";
import LeadAssAll from "./leadsAssAll.js";
import LeadAssTest from "./leadAss_test.js";
import LeadAssAllNew from "./leadsAssAllNew.js";
import LeadAssNew from "./leadAssNew.js";
import LeadOpinionsNew from "./leadOpinionsNew.js";
import LeadFinalizedNew from "./leadFinalizedNew.js";
import LeadRekNew from "./leadsRekNew.js";
import AddLeadRecommendation from "./addLeadRecommendation.js";
import SellerRankEdit from "./sellerRankEdit.js";
import AppStatistics from "./appStatistics.js";
import Holiday from "./holidays.js";
import FreeLeads from "./freeLeads.js";
import LeadQue2 from "./leadsQue2.js";

const MySwal = withReactContent(Swal2);

const Main = (props) => {
  const [loading, setLoading] = useState(true);
  const [showMenu, setShowMenu] = useState(true);
  const [option, setOption] = useState(
    props.ccForm
      ? 7
      : props.user.role === "user" || props.user.role === "userplus"
      ? 1
      : 0
  );

  useEffect(() => {
    setLoading(false);
  }, []);

  const logAction = async (id, content) => {
    var body = {
      leadId: id,
      content: content,
    };

    await fetch("https://apisplit.ftpeople.pl/addLog", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div style={{ display: "flex", minHeight: "100vh" }}>
            <div
              style={
                showMenu
                  ? {
                      minWidth: "15vw",
                      maxWidth: "15vw",
                      backgroundColor: "#ffa500",
                      padding: "2% 1%",
                      height: "100vh",
                      position: "sticky",
                      top: "0",
                      display: "block",
                    }
                  : { display: "none" }
              }
            >
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "2vw",
                  margin: "0",
                  marginBottom: "5vh",
                }}
              >
                LEADS SPLITTER
                <br />
                <span style={{ fontWeight: "300", fontSize: "1vw" }}>
                  by FTP
                </span>
              </p>
              <div style={{ overflowY: "scroll", height: "65vh" }}>
                {props.user.role === "admin" && !props.ccForm ? (
                  <button
                    style={{
                      borderRadius: "5px",
                      border: "1px solid white",
                      width: "100%",
                      height: "3vh",
                      backgroundColor: "white",
                      cursor: "pointer",
                      margin: "1vh 0",
                      fontWeight: "600",
                      fontSize: "1vw",
                    }}
                    value={0}
                    onClick={(e) => setOption(+e.target.value)}
                  >
                    KOLEJKA
                  </button>
                ) : (
                  ""
                )}
                {props.user.role === "admin" ? (
                  <button
                    style={{
                      borderRadius: "5px",
                      border: "1px solid white",
                      width: "100%",
                      height: "3vh",
                      backgroundColor: "white",
                      cursor: "pointer",
                      margin: "1vh 0",
                      fontWeight: "600",
                      fontSize: "1vw",
                    }}
                    value={19}
                    onClick={(e) => setOption(+e.target.value)}
                  >
                    KOLEJKA - ODDZIAŁY
                  </button>
                ) : (
                  ""
                )}
                {props.user.role === "admin" && !props.ccForm ? (
                  <button
                    style={{
                      borderRadius: "5px",
                      border: "1px solid white",
                      width: "100%",
                      height: "3vh",
                      backgroundColor: "white",
                      cursor: "pointer",
                      margin: "1vh 0",
                      fontWeight: "600",
                      fontSize: "1vw",
                    }}
                    value={4}
                    onClick={(e) => setOption(+e.target.value)}
                  >
                    DUBLE
                  </button>
                ) : (
                  ""
                )}
                {!props.ccForm && props.user.role === "admin" ? (
                  <>
                    <button
                      style={{
                        borderRadius: "5px",
                        border: "1px solid white",
                        width: "100%",
                        height: "3vh",
                        backgroundColor: "white",
                        cursor: "pointer",
                        margin: "1vh 0",
                        fontWeight: "600",
                        fontSize: "1vw",
                      }}
                      value={11}
                      onClick={(e) => setOption(+e.target.value)}
                    >
                      LEADY - WSZYSTKIE
                    </button>
                  </>
                ) : (
                  ""
                )}

                {!props.ccForm ? (
                  <>
                    <button
                      style={{
                        borderRadius: "5px",
                        border: "1px solid white",
                        width: "100%",
                        height: "3vh",
                        backgroundColor: "white",
                        cursor: "pointer",
                        margin: "1vh 0",
                        fontWeight: "600",
                        fontSize: "1vw",
                      }}
                      value={1}
                      onClick={(e) => setOption(+e.target.value)}
                    >
                      LEADY
                    </button>
                  </>
                ) : (
                  ""
                )}
                {false && !props.ccForm ? (
                  <>
                    <button
                      style={{
                        borderRadius: "5px",
                        border: "1px solid white",
                        width: "100%",
                        height: "3vh",
                        backgroundColor: "white",
                        cursor: "pointer",
                        margin: "1vh 0",
                        fontWeight: "600",
                        fontSize: "1vw",
                      }}
                      value={6}
                      onClick={(e) => setOption(+e.target.value)}
                    >
                      POLECENIA
                    </button>
                  </>
                ) : (
                  ""
                )}
                {!props.ccForm ? (
                  <>
                    <button
                      style={{
                        borderRadius: "5px",
                        border: "1px solid white",
                        width: "100%",
                        height: "3vh",
                        backgroundColor: "white",
                        cursor: "pointer",
                        margin: "1vh 0",
                        fontWeight: "600",
                        fontSize: "1vw",
                      }}
                      value={8}
                      onClick={(e) => setOption(+e.target.value)}
                    >
                      OPINIE
                    </button>
                  </>
                ) : (
                  ""
                )}
                {!props.ccForm ? (
                  <>
                    <button
                      style={{
                        borderRadius: "5px",
                        border: "1px solid white",
                        width: "100%",
                        height: "3vh",
                        backgroundColor: "white",
                        cursor: "pointer",
                        margin: "1vh 0",
                        fontWeight: "600",
                        fontSize: "1vw",
                      }}
                      value={9}
                      onClick={(e) => setOption(+e.target.value)}
                    >
                      SPISANI
                    </button>
                  </>
                ) : (
                  ""
                )}
                {!props.ccForm ? (
                  <>
                    <button
                      style={{
                        borderRadius: "5px",
                        border: "1px solid white",
                        width: "100%",
                        height: "3vh",
                        backgroundColor: "white",
                        cursor: "pointer",
                        margin: "1vh 0",
                        fontWeight: "600",
                        fontSize: "1vw",
                      }}
                      value={10}
                      onClick={(e) => setOption(+e.target.value)}
                    >
                      REKLAMACJE
                    </button>
                  </>
                ) : (
                  ""
                )}

                {false && !props.ccForm ? (
                  <>
                    <button
                      style={{
                        borderRadius: "5px",
                        border: "1px solid white",
                        width: "100%",
                        height: "3vh",
                        backgroundColor: "white",
                        cursor: "pointer",
                        margin: "1vh 0",
                        fontWeight: "600",
                        fontSize: "1vw",
                      }}
                      value={5}
                      onClick={(e) => setOption(+e.target.value)}
                    >
                      KALENDARZ ZADAŃ
                    </button>
                  </>
                ) : (
                  ""
                )}
                {!props.ccForm ? (
                  <>
                    <button
                      style={{
                        borderRadius: "5px",
                        border: "1px solid white",
                        width: "100%",
                        height: "3vh",
                        backgroundColor: "white",
                        cursor: "pointer",
                        margin: "1vh 0",
                        fontWeight: "600",
                        fontSize: "1vw",
                      }}
                      value={2}
                      onClick={(e) => setOption(+e.target.value)}
                    >
                      RANKING
                    </button>
                  </>
                ) : (
                  ""
                )}
                {!props.ccForm &&
                (props.user.role === "admin" ||
                  props.user.role === "userplus") ? (
                  <>
                    <button
                      style={{
                        borderRadius: "5px",
                        border: "1px solid white",
                        width: "100%",
                        height: "3vh",
                        backgroundColor: "white",
                        cursor: "pointer",
                        margin: "1vh 0",
                        fontWeight: "600",
                        fontSize: "1vw",
                      }}
                      value={15}
                      onClick={(e) => setOption(+e.target.value)}
                    >
                      STATYSTYKI
                    </button>
                  </>
                ) : (
                  ""
                )}
                {!props.ccForm &&
                (props.user.role === "admin" ||
                  props.user.role === "userplus") ? (
                  <>
                    <button
                      style={{
                        borderRadius: "5px",
                        border: "1px solid white",
                        width: "100%",
                        height: "3vh",
                        backgroundColor: "white",
                        cursor: "pointer",
                        margin: "1vh 0",
                        fontWeight: "600",
                        fontSize: "1vw",
                      }}
                      value={14}
                      onClick={(e) => setOption(+e.target.value)}
                    >
                      RANKING - EDYCJA
                    </button>
                  </>
                ) : (
                  ""
                )}
                {(props.user.role === "user" || props.user.role === "admin") &&
                !props.ccForm ? (
                  <button
                    style={{
                      borderRadius: "5px",
                      border: "1px solid white",
                      width: "100%",
                      height: "3vh",
                      backgroundColor: "white",
                      cursor: "pointer",
                      margin: "1vh 0",
                      fontWeight: "600",
                      fontSize: "1vw",
                    }}
                    value={13}
                    onClick={(e) => setOption(+e.target.value)}
                  >
                    DODAJ LEAD
                  </button>
                ) : (
                  ""
                )}
                {(props.user.role === "user" ||
                  props.user.role === "userplus") &&
                !props.ccForm ? (
                  <button
                    style={{
                      borderRadius: "5px",
                      border: "1px solid white",
                      width: "100%",
                      height: "3vh",
                      backgroundColor: "white",
                      cursor: "pointer",
                      margin: "1vh 0",
                      fontWeight: "600",
                      fontSize: "1vw",
                    }}
                    value={16}
                    onClick={(e) => setOption(+e.target.value)}
                  >
                    URLOPY
                  </button>
                ) : (
                  ""
                )}
                {props.user.role === "admin" && !props.ccForm ? (
                  <button
                    style={{
                      borderRadius: "5px",
                      border: "1px solid white",
                      width: "100%",
                      height: "3vh",
                      backgroundColor: "white",
                      cursor: "pointer",
                      margin: "1vh 0",
                      fontWeight: "600",
                      fontSize: "1vw",
                    }}
                    value={17}
                    onClick={(e) => setOption(+e.target.value)}
                  >
                    URLOPY - ADMIN
                  </button>
                ) : (
                  ""
                )}
                {props.user.role === "admin" && !props.ccForm ? (
                  <button
                    style={{
                      borderRadius: "5px",
                      border: "1px solid white",
                      width: "100%",
                      height: "3vh",
                      backgroundColor: "white",
                      cursor: "pointer",
                      margin: "1vh 0",
                      fontWeight: "600",
                      fontSize: "1vw",
                    }}
                    value={18}
                    onClick={(e) => setOption(+e.target.value)}
                  >
                    ZWOLNIJ LEADY
                  </button>
                ) : (
                  ""
                )}
                {props.user.role === "admin" && !props.ccForm ? (
                  <button
                    style={{
                      borderRadius: "5px",
                      border: "1px solid white",
                      width: "100%",
                      height: "3vh",
                      backgroundColor: "white",
                      cursor: "pointer",
                      margin: "1vh 0",
                      fontWeight: "600",
                      fontSize: "1vw",
                    }}
                    value={3}
                    onClick={(e) => setOption(+e.target.value)}
                  >
                    ADMIN
                  </button>
                ) : (
                  ""
                )}
              </div>
              {props.ccForm ? (
                <p
                  style={{
                    color: "white",
                    fontWeight: "600",
                    textAlign: "left",
                  }}
                >
                  Wprowadź dane klienta pozyskanego w rozmowie telefonicznej. Po
                  kliknięciu przycisku "DODAJ LEAD" formularz zostanie
                  wyczyszczony celem dalszego wprowadzania. Pola "źródło" oraz
                  "id źródło" są uzupełniane automatycznie oraz wyłaczone do
                  edycji.
                </p>
              ) : (
                ""
              )}

              <div
                style={{
                  textTransform: "uppercase",
                  opacity: ".4",
                  marginTop: "5vh",
                }}
              >
                <p style={{ margin: "0", fontSize: "1vw" }}>Zalogowany</p>
                <p style={{ margin: "0", fontSize: ".8vw" }}>
                  {props.user.name}
                </p>
              </div>
              <button
                style={{
                  borderRadius: "25px",
                  border: "none",
                  width: "50%",
                  height: "2vh",
                  backgroundColor: "transparent",
                  cursor: "pointer",
                  margin: "1vh 0",
                  fontWeight: "400",
                }}
                value={3}
                onClick={(e) => window.location.reload(false)}
              >
                WYLOGUJ
              </button>
            </div>
            <div
              style={{
                backgroundColor: "orange",
                height: "30px",
                width: "40px",
                position: "sticky",
                top: "10px",
                marginRight: "-2%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderTopRightRadius: "15px",
                borderBottomRightRadius: "15px",
              }}
            >
              <button
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  color: "white",
                  fontWeight: "900",
                  cursor: "pointer",
                  fontSize: "1vw",
                }}
                onClick={(e) => {
                  setShowMenu(!showMenu);
                }}
              >
                {showMenu ? "<" : ">"}
              </button>
            </div>
            <div
              style={{
                padding: "0% 2%",
                minHeight: "100vh",
                width: "100%",
              }}
            >
              {option === 0 ? (
                <>
                  <LeadQue user={props.user} logAction={logAction} />
                </>
              ) : (
                ""
              )}
              {option === 19 ? (
                <>
                  <LeadQue2 user={props.user} logAction={logAction} />
                </>
              ) : (
                ""
              )}
              {option === 1 ? (
                <>
                  <LeadAssNew user={props.user} logAction={logAction} />
                </>
              ) : (
                ""
              )}
              {option === 2 ? (
                <>
                  <SellerRank user={props.user} logAction={logAction} />
                </>
              ) : (
                ""
              )}
              {option === 3 ? (
                <>
                  <AdminPanel user={props.user} logAction={logAction} />
                </>
              ) : (
                ""
              )}
              {option === 4 ? (
                <>
                  <Doubles user={props.user} logAction={logAction} />
                </>
              ) : (
                ""
              )}
              {option === 5 ? (
                <>
                  <TaskCalendar user={props.user} logAction={logAction} />
                </>
              ) : (
                ""
              )}
              {option === 6 ? (
                <>
                  <Recommendations user={props.user} logAction={logAction} />
                </>
              ) : (
                ""
              )}
              {option === 7 ? (
                <>
                  <CcForm logAction={logAction} />
                </>
              ) : (
                ""
              )}
              {option === 8 ? (
                <>
                  <LeadOpinionsNew user={props.user} logAction={logAction} />
                </>
              ) : (
                ""
              )}
              {option === 9 ? (
                <>
                  <LeadFinalizedNew user={props.user} logAction={logAction} />
                </>
              ) : (
                ""
              )}
              {option === 10 ? (
                <>
                  <LeadRekNew user={props.user} logAction={logAction} />
                </>
              ) : (
                ""
              )}
              {option === 11 ? (
                <>
                  <LeadAssAllNew user={props.user} logAction={logAction} />
                </>
              ) : (
                ""
              )}
              {option === 12 ? (
                <>
                  <LeadAssTest user={props.user} logAction={logAction} />
                </>
              ) : (
                ""
              )}
              {option === 13 ? (
                <>
                  <AddLeadRecommendation
                    user={props.user}
                    close={() => setOption(1)}
                    logAction={logAction}
                  />
                </>
              ) : (
                ""
              )}
              {option === 14 ? (
                <>
                  <SellerRankEdit user={props.user} logAction={logAction} />
                </>
              ) : (
                ""
              )}
              {option === 15 ? (
                <>
                  <AppStatistics user={props.user} logAction={logAction} />
                </>
              ) : (
                ""
              )}
              {option === 16 ? (
                <>
                  <Holiday user={props.user} logAction={logAction} />
                </>
              ) : (
                ""
              )}
              {option === 17 ? (
                <>
                  <Holiday user={props.user} logAction={logAction} />
                </>
              ) : (
                ""
              )}
              {option === 18 ? (
                <>
                  <FreeLeads user={props.user} logAction={logAction} />
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Main;
